export default __webpack_public_path__ + "static/media/patient.29682a19.png";